import { render, staticRenderFns } from "./LogoutButton.vue?vue&type=template&id=b9f4c412"
import script from "./LogoutButton.vue?vue&type=script&lang=js"
export * from "./LogoutButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports